import ProposalCard, { ProposalCardSkeleton } from "./ProposalCard";

export { ProposalCardSkeleton };
export default ProposalCard;
